<script lang="ts">
  export let stretch = false;
  export let color = "accent";
  export let size = "large";

  export let spaced = false;
  export let disabled = false;
</script>

<button
  style="--button-color: var(--rekki-{color})"
  {disabled}
  class:spaced
  class:stretch
  class="text-{size}"
  on:click
  ><div class="container"><slot /></div>
</button>

<style>
  button {
    display: inline-block;
    box-sizing: border-box;
    min-height: 76px;
    flex: 1;
    border-radius: 58px;
    background-color: var(--button-color);
    padding: 8px;
    color: var(--rekki-light);
    border: 0 none;
    white-space: nowrap;
    font-family: "REKKI-OCD";
    font-size: 22px;
    line-height: 16px;
    letter-spacing: 0.2px;
    text-transform: uppercase;
  }

  .spaced {
    padding: 8px 120px;
    min-height: 112px;
  }

  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
  }

  .stretch {
    width: 100%;
  }

  button:active {
    filter: brightness(1.1);
  }
  button:disabled {
    background-color: var(--rekki-neutral-02);
    color: var(--rekki-neutral-03);
    pointer-events: none;
  }
</style>
